import { formatCurrency } from "@/shared/utils/formatters";
import type { EstateItem } from "@/shared/types/estateTypes";

export function buildInsuranceSubtitle(item: EstateItem): string {
  const meta = (item.metadata ?? {}) as Record<string, unknown>;
  const parts: string[] = [];
  if (item.item_type) parts.push(item.item_type);
  if (typeof meta.policy_number === "string" && meta.policy_number) {
    parts.push(`Policy #${meta.policy_number}`);
  }
  if (item.balance) parts.push(formatCurrency(item.balance));
  return parts.join(" \u00b7 ");
}

export function buildLtcSubtitle(item: EstateItem): string {
  const meta = (item.metadata ?? {}) as Record<string, unknown>;
  const parts: string[] = [];
  if (typeof meta.policy_number === "string" && meta.policy_number) {
    parts.push(`Policy #${meta.policy_number}`);
  }
  if (item.balance) parts.push(`${formatCurrency(item.balance)}/day`);
  if (typeof meta.benefit_period === "string" && meta.benefit_period) {
    parts.push(meta.benefit_period);
  }
  return parts.join(" \u00b7 ");
}
